import { isUserAuthenticated } from "@/middleware/auth";

import { SocketEventActionType, GroupRequestEventType } from "./types";
import { queryClient } from "@/queryClient";

export const handleGroupRequestEvent = async (data: GroupRequestEventType) => {
  // extra check if auth is present
  const userFingerPrint = isUserAuthenticated();
  if (!userFingerPrint) {
    return;
  }

  switch (data.action) {
    case SocketEventActionType.CREATE:
      // handle join request
      await onJoinRequest({ eventPayload: data });
      break;
    case SocketEventActionType.UPDATE:
      break;
    case SocketEventActionType.DELETE:
      // handle deny request
      await onDenyRequest({ eventPayload: data });
      break;

    default:
      break;
  }
};

const onDenyRequest = async ({
  eventPayload,
}: {
  eventPayload: GroupRequestEventType;
}) => {
  // extra check if auth is present
  const userFingerPrint = isUserAuthenticated();
  if (!userFingerPrint) {
    return;
  }

  const isCurrentUser =
    eventPayload.request.username === userFingerPrint.username;

  if (isCurrentUser) {
    // invaliudate the query for the current user's requests
    queryClient.invalidateQueries({
      queryKey: ["public-groups-user-requests"],
    });

    // invalidate the query for the public groups
    queryClient.invalidateQueries({
      queryKey: ["search-public-groups"],
    });
  }
};

const onJoinRequest = async ({
  eventPayload,
}: {
  eventPayload: GroupRequestEventType;
}) => {
  // extra check if auth is present
  const userFingerPrint = isUserAuthenticated();
  if (!userFingerPrint) {
    return;
  }

  // invalidate the query for the specific chat's user requests
  queryClient.invalidateQueries({
    queryKey: ["public-group-users-requests", eventPayload.request.chat_id],
  });
};
